var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "circle place holder_ic"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 7374",
    fill: "#fff",
    stroke: "#52b0d9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Forma 1",
    d: "M31.999 10.791a10.025 10.025 0 11-10.023 10.025 10.025 10.025 0 0110.023-10.025zm-.007 43.629a22.242 22.242 0 01-14.484-5.341 4.271 4.271 0 01-1.5-3.248 10.11 10.11 0 0110.159-10.106h11.667a10.1 10.1 0 0110.143 10.106 4.263 4.263 0 01-1.5 3.247 22.235 22.235 0 01-14.484 5.343z",
    fill: "#1c97cf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.155c20f7.svg";
export { ForwardRef as ReactComponent };